/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, AfterViewInit, OnDestroy, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { CheckedUncheckedPipe } from '../../shared/pipes/checkedUnchecked.pipe';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { ServiceItemsListService } from '../services/serviceitems.service';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { Subscription } from 'rxjs';
import { ServicesFilterInfo } from '../model/serviceitemsfilterinfo';
import { CommonConstants } from '../../../../common/constants/common-constants';
declare var $: any;

@Component({
  selector: 'zsd-servicesfilter',
  templateUrl: '../view/serviceitemsfilter.component.html',
  providers : [ CheckedUncheckedPipe ],
  encapsulation: ViewEncapsulation.None
})
export class ServiceItemsFilterComponent implements AfterViewInit, OnDestroy, OnInit, AfterViewChecked {

  static searchString = null;
  static selectedCategories = null;
  static selectedItemTypes = null;
  static categoryIds = null;
  static serviceType = null;
  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();
  searchCategory:  string;
  searchItemType: string;
  servicesFilterInfo: ServicesFilterInfo = new ServicesFilterInfo();
  searchSubscription: Subscription;
  windowSize;
  isFilterOpen: boolean;

  categoryChecked = false;
  itemTypeChecked = false;

 constructor(private servicesService: ServiceItemsListService, private checkedUncheckedPipe: CheckedUncheckedPipe,
  private router: Router, private route: ActivatedRoute, private location: PlatformLocation) {
   this.windowSize = window.innerWidth;
   this.initializeParameters();
   this.location.onPopState(() => {
     this.ngOnInit();
   });
   this.location.onHashChange(() => {
     this.ngOnInit();
   });

 }
 ngOnInit() {
    this.initFilter();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    // a hack to fix filter display issue when protrait and landscape mode has mobile and desktop layout respectively.
  }
 initializeParameters() {
  ServiceItemsFilterComponent.selectedCategories = null;
  ServiceItemsFilterComponent.selectedItemTypes = null;
  ServiceItemsFilterComponent.searchString = null;
  this.servicesFilterInfo.searchTerm = null;
  this.servicesFilterInfo.serviceType = null;
}

ngAfterViewChecked() {
  this.windowSize = window.innerWidth;
}

closeFilter() {
  this.isFilterOpen = false;
  $('#services_filterpanel_control').width('0');
  $('body').css('overflow-y', 'auto');
}


initFilter() {
  let categoryIds = new Array<number>();
  let itemTypeIds = new Array<number>();
  this.route.queryParams.subscribe(params => {
     if (params['searchTerm']) {
       this.servicesFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
     }
     if (params['serviceType']) {
      this.servicesFilterInfo.serviceType = JSON.parse(params['serviceType']);
    }
    if (params['categoryIds']) {
      categoryIds = JSON.parse(params['categoryIds']);
      if (categoryIds.length > 0) {
        this.categoryChecked = true;
      }
    }
    if (params['itemTypeIds']) {
      itemTypeIds = JSON.parse(params['itemTypeIds']);
      if (itemTypeIds.length > 0) {
        this.itemTypeChecked = true;
      }
    }
  });

  if (this.servicesFilterInfo.searchTerm !== null) {
    ServiceItemsFilterComponent.searchString = this.servicesFilterInfo.searchTerm.toString();
  }

  if (this.servicesFilterInfo.serviceType !== null) {
    ServiceItemsFilterComponent.serviceType = this.servicesFilterInfo.serviceType.toString();
  }

  this.getCategories(categoryIds);
  this.getItemtypes(itemTypeIds);
}

getCategories(categoryIds: Array<number>) {
  this.servicesService.getItemCategories().subscribe(
    (categoryResponse: ItemCategoriesResultEntity[]) => {
          this.categoryResults = categoryResponse;
          for (let categoryId of categoryIds) {
            for (let j = 0; j < this.categoryResults.length; j++) {
              if (this.categoryResults[j].categoryId === categoryId) {
                this.categoryResults[j].checked = true;
              }
            }
          }
          this.categoryResults = this.checkedUncheckedPipe.transform(this.categoryResults, 'categoryName');
    }
  );
}


getItemtypes(itemTypeIds: Array<number>) {
  this.servicesService.getItemTypes().subscribe(
    (itemTypesResponses: ItemTypesResultEntity[]) => {
      this.itemTypesResults = itemTypesResponses;

      for (let itemTypeId of itemTypeIds) {
        for (let j = 0; j < this.itemTypesResults.length; j++) {
          if (this.itemTypesResults[j].itemTypeId === itemTypeId) {
            this.itemTypesResults[j].checked = true;
          }
        }
      }
      this.itemTypesResults = this.checkedUncheckedPipe.transform(this.itemTypesResults, 'itemTypeName');
    });
}

applyFilter() {
  this.categoryResults = this.categoryResults.filter(category => category.checked === true);
  this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);

  let categoryIds = new Array<number>();
  for (let itemCategory of this.categoryResults) {
    categoryIds.push(itemCategory.categoryId);
  }

  let itemTypeIds = new Array<number>();
  for (let itemType of this.itemTypesResults) {
    itemTypeIds.push(itemType.itemTypeId);
  }

  if (ServiceItemsFilterComponent.searchString !== null) {
    ServiceItemsFilterComponent.searchString = JSON.stringify(ServiceItemsFilterComponent.searchString);
  }

  if (ServiceItemsFilterComponent.serviceType !== null) {
    ServiceItemsFilterComponent.serviceType = JSON.stringify(ServiceItemsFilterComponent.serviceType);
  }
  if (categoryIds.length > 0) {
    ServiceItemsFilterComponent.selectedCategories = JSON.stringify(categoryIds);
    this.servicesFilterInfo.categoryIds = categoryIds;
  }
  if (itemTypeIds.length > 0) {
    ServiceItemsFilterComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
    this.servicesFilterInfo.itemTypeIds = itemTypeIds;
  }

  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': ServiceItemsFilterComponent.searchString,
      'categoryIds': ServiceItemsFilterComponent.selectedCategories,
      'itemTypeIds': ServiceItemsFilterComponent.selectedItemTypes,
      'serviceType': ServiceItemsFilterComponent.serviceType
    },
    queryParamsHandling: 'merge'
  };

  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([CommonConstants.SERVICES_COMPONENT], navigationExtras ));

  this.closeFilter();
}

 // will be called on click of clear button
 clearFilter() {
  this.resetFilter();
  if (ServiceItemsFilterComponent.searchString !== null) {
    ServiceItemsFilterComponent.searchString = JSON.stringify(ServiceItemsFilterComponent.searchString);
  }
  if (ServiceItemsFilterComponent.serviceType !== null) {
    ServiceItemsFilterComponent.serviceType = JSON.stringify(ServiceItemsFilterComponent.serviceType);
  }
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': ServiceItemsFilterComponent.searchString,
      'serviceType': ServiceItemsFilterComponent.serviceType
    },
    queryParamsHandling: 'merge'
  };
  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([CommonConstants.SERVICES_COMPONENT], navigationExtras ));

  this.closeFilter();
}

// will reset the selected filter values
resetFilter() {
  ServiceItemsFilterComponent.selectedCategories = null;
  ServiceItemsFilterComponent.selectedItemTypes = null;
  this.searchCategory = '';
  this.searchItemType = '';
  this.categoryResults.forEach(category => category.checked = false);
  this.itemTypesResults.forEach(itemType => itemType.checked = false);
}

ngAfterViewInit() {
  $(document).ready(function () {
    $('[data-toggle=popover]').popover();
  });
}


ngOnDestroy() {
}



}
